<template>
  <div
    @click.stop="activeItem(item, _uid)"
    @mouseover="pause = true"
    @mouseleave="active_details ? (pause = true) : (pause = false)"
    :ref="item.symbol"
    class="mx-1.5 flex transform cursor-pointer items-center space-x-2 rounded-lg px-3 py-3 text-sm transition-all duration-200"
    :class="
      active_index == _uid
        ? 'bg-ontick-steel-100 dark:bg-ontick-steel-500 scale-105'
        : 'dark:bg-ontick-graphite-500 bg-gray-50'
    "
  >
    <span class="text-ontick-steel-900 font-medium dark:text-gray-300">
      {{ item.symbol }}</span
    >

    <transition name="slide-fade" mode="out-in">
      <div class="flex items-center">
        <div
          v-show="item.perc_change == 0"
          class="text-ontick-steel-900 h-3 w-3 rounded-full dark:bg-gray-500"
        ></div>
        <svg
          width="13"
          height="10"
          viewBox="0 0 13 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          v-show="item.perc_change > 0 || item.perc_change < 0"
          class="transform transition-all duration-200"
          :class="item.perc_change > 0 ? 'rotate-0' : 'rotate-180'"
        >
          <path
            d="M12.5 10H0L6.25 0L12.5 10Z"
            :fill="item.perc_change > 0 ? '#19D684' : '#F56565'"
          />
        </svg>
        <span
          :key="item.last"
          :class="[
            item.last >= 0 ? 'alta' : 'baixa',
            'text-ontick-steel-900 text-center dark:text-gray-200',
          ]"
          class="ml-2"
        >
          {{
            item.symbol.endsWith("FUT")
              ? item.last
              : parseFloat(item.last).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                  minimumFractionDigits: item.decimal_places,
                })
          }}
        </span>
      </div>
    </transition>
    <transition name="slide-fade" mode="out-in">
      <span
        :class="
          item.perc_change > 0
            ? 'text-ontick-green-700 dark:text-ontick-green-500'
            : item.perc_change == 0
            ? 'text-ontick-steel-900 dark:text-gray-300'
            : 'text-ontick-red-600 dark:text-ontick-red-500'
        "
        class="font-semibold"
      >
        {{ item.perc_change >= 0 ? "+" : "" }}
        {{
          parseFloat(item.perc_change).toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
          })
        }}%</span
      >
    </transition>
    <transition-group
      enter-active-class="transform transition ease-in-out duration-500 sm:duration-700"
      enter-class="translate-y-full"
      enter-to-class="translate-y-0"
      leave-active-class="transform transition ease-in-out duration-500 sm:duration-700"
      leave-class="translate-y-0"
      leave-to-class="translate-y-full"
    >
      <dashboard-badge-component
        v-if="active_details && _uid === active_index"
        :decimal_place="item.decimal_places"
        :data="data_details"
        :chart="chart"
        :key="_uid"
      />
    </transition-group>
  </div>
</template>

<script>
import DashboardBadgeComponent from "../../../modules/dashboard/components/dashboard.badge.component.vue";

export default {
  props: {
    item: {
      type: Object,
    },
    active_index: {
      type: Number,
    },
  },
  components: { DashboardBadgeComponent },
  data() {
    return {
      active_details: false,
      // active_index: null,
      chart: [],
      data_details: {},
      pause: false,
    };
  },
  methods: {
    activeItem(value, index) {
      if (this.active_index == index) {
        this.active_details = false;
        // this.active_index = null;
        this.$emit("active-index", null);
      } else {
        this.tickerDetails(value.symbol);
        this.active_details = true;
        // this.active_index = index;
        this.$emit("active-index", index);
      }
    },

    tickerDetails(symbol) {
      this.$api
        .get(`${this.$endpoint.GET_TICKER_DETAILS}/${symbol}`)
        .then((response) => {
          this.data_details = response.data.summary;
          this.chart = response.data.sparkline;
        });
    },
  },
  watch: {
    active_details() {
      this.$emit("active-details", this._uid);
    },
  },
};
</script>

<style></style>
